export default "__VITE_ASSET__D04h$KCy__"